export function setActiveSchool({commit}, school){
    commit('SET_ACTIVE_SCHOOL', school);
}